import { GooglePlaceConverter } from "@/components/Shared/GooglePlace/GooglePlace";
import { forEach, isEmpty } from "lodash";
import store from "@/modules";

const updateInput = (el) => {
  el.dispatchEvent(new Event("input", { bubbles: true }));
};

let gpManager = Object.create({
  autocomplete: null,
  googlePlaceOn: true,
  el: null,
  inputEl: null,
  vnode: null,
  listener: null,
  callback() {
    if (this.googlePlaceOn) {
      let result, gPlace;
      gPlace = this.autocomplete.getPlace();
      result = GooglePlaceConverter.init(gPlace).toJSON();
      this.inputEl.value = result.address1;
      updateInput(this.el);
      this.vnode.child.$emit("selected", result);
    }
  },
  showAutocomplete() {
    this.forEachContainer((container) => {
      container.style.visibility = "visible";
      container.style.zIndex = "5000";
    });
  },
  hideAutocomplete() {
    this.forEachContainer(
      (container) => (container.style.visibility = "hidden")
    );
  },
  destroy() {
    // Remove all listeners added to input element.
    google.maps.event.clearInstanceListeners(this.inputEl);
    /* TODO: in case multiple google place autocomplete components need to be working at the same page
     *  the following code would not work. As it is not the case for now. the solution is good enough.
     * */
    this.forEachContainer((tag) => tag.remove());
  },
  forEachContainer(callback) {
    let pacContainers = document.getElementsByClassName("pac-container");
    forEach(pacContainers, callback);
  },
});
gpManager.callback.bind(gpManager);

export default {
  bind(el, binding, vnode) {
    let inputEl = vnode.elm.firstElementChild;
    let options = { types: ["address"] };
    if (store.getters["shared/ISTFormOpen"])
      options.componentRestrictions = {
        country: ["us", "ca"],
      };

    gpManager.autocomplete = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */ (inputEl),
      options
    );
    gpManager.listener = gpManager.autocomplete.addListener(
      "place_changed",
      () => {
        gpManager.callback();
      }
    );
  },
  update(el, binding, vnode) {
    let inputEl = vnode.elm.firstElementChild;
    gpManager.googlePlaceOn = Boolean(binding.value);
    if (gpManager.googlePlaceOn) {
      gpManager.inputEl = inputEl;
      gpManager.el = el;
      gpManager.vnode = vnode;
      gpManager.showAutocomplete();
    } else {
      gpManager.hideAutocomplete();
    }
  },
  unbind(el, binding, vnode) {
    gpManager.inputEl = vnode.elm.firstElementChild;
    gpManager.destroy();
  },
};
